import React from 'react'

import ButtonClear from '../../ui/ButtonClear'
import Icons from '../../ui/Icons'

function ModalFormSecurity({
  isVisible,
  onClose,
  canDismiss,
  title,
  description,
  hideButton,
  buttonTitle,
  genericIcon,
}) {
  return (
    isVisible && (
      <div className="z-10 fixed right-0 top-0 left-0 bottom-0 m-0 clearfix flex items-center justify-center bg-screen">
        <div className="flex flex-1 flex-col items-center px-5 pb-4 pt-15 bg-white rounded max-w-3xl space-y-9 shadow-lg">
          {title && (
            <h1 className="text-center text-3xl font-weight-bold text-txt-emphasis break-keep">
              {title}
            </h1>
          )}
          {genericIcon ? (
            <Icons.CubeEmpty
              className="mt-4"
              color="text-yellow-300"
              size={20}
            />
          ) : (
            <Icons.ClipboardList
              className="mt-4"
              color="text-yellow-300"
              size={20}
            />
          )}
          {description && (
            <p className="text-center text-md text-txt">{description}</p>
          )}
          <div className="flex justify-center">
            {!hideButton && (
              <ButtonClear onClick={onClose}>
                {buttonTitle || 'Dismiss'}
              </ButtonClear>
            )}
          </div>
        </div>
      </div>
    )
  )
}

export default ModalFormSecurity
